import { useShowPWAModal } from '@patrianna/shared-hooks'
import cx from 'classnames'
import { type FC } from 'react'

import AccountIdMessage from 'containers/AccountIdMessage'
import usePWAInstance, { useIsPWAAvailable } from 'hooks/usePWA'

import PWAInfo from '../PWAInfo'
import SocialButtons from '../SocialButtons'

import classes from './styles.module.scss'

const MenuFooter: FC<{ handleTrackEvent: (name: string) => void }> = ({ handleTrackEvent }) => {
  const pwaInstance = usePWAInstance()
  const isPwaAvailable = useIsPWAAvailable()
  const isPWAInit = Boolean(isPwaAvailable && pwaInstance)
  const shouldShowPWA = useShowPWAModal()

  return (
    <>
      <div className={cx(classes.root, isPWAInit && classes.withPwa)} data-test='menu-footer-links'>
        {isPWAInit && shouldShowPWA() && <PWAInfo pwaInstance={pwaInstance} />}
        <SocialButtons handleTrackEvent={handleTrackEvent} />
      </div>
      <AccountIdMessage />
    </>
  )
}

export default MenuFooter
